$(function () {
  const $wrapper = $(".mobile-global-link-wrapper");
  let currentSection = 1;
  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  $(".global-link-header-logo a").on("keydown", function (e) {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      $(".global-link-close button:visible").focus();
    }
  });

  $(".global-link-close").click(function () {
    $("#global-link-wrapper").hide();
    $("#global-link-wrapper").attr('aria-hidden', 'true');

    // Collapse all accordion panels
    $(".accordion-collapse.show").each(function () {
      $(this).collapse("hide");
    });

    // Hide all submenus in brand-wrapper
    $(".brand-wrapper").each(function () {
      $(this).hide().find('div[id^="subMenu-"]').hide();
    });

    // Remove active states from links
    $(".second-level, .first-level").removeClass("active-region-link");

    // Reset focus trap (optional)
    trapFocusForDesktop($("#desktop-global-link-wrapper"), true);
  });

  const accordionItems = document.querySelectorAll(".accordion-item");

// Loop through each accordion item
    accordionItems.forEach(item => {
      const collapseEl = item.querySelector(".accordion-collapse");

      if (collapseEl) {
        // On accordion open
        collapseEl.addEventListener("shown.bs.collapse", () => {
          // Remove 'active' from all
          accordionItems.forEach(i => i.classList.remove("active"));
          // Add 'active' only to the current item
          item.classList.add("active");
        });

        // On accordion close
        collapseEl.addEventListener("hidden.bs.collapse", () => {
          item.classList.remove("active");
        });
      }
   });

  
  $(".E-aside-nav-link").on("click", function (e) {
    const targetID = $(this).data("target");
    const $panel = $(targetID);
    $(".global-link-wrapper-section-1").addClass("active");
    if ($panel.length) {

      $("#global-link-wrapper").show();
      $("#global-link-wrapper").attr('aria-hidden', 'false');

      const focusTarget = document.getElementById("global-link-wrapper");

      const allChildren = Array.from($panel.children().children());
      allChildren.forEach((child) => {
        if (!child.contains(focusTarget)) {
          child.setAttribute("aria-hidden", "true");
        }
      });

      const headerLogo = document.querySelector(".global-link-header-logo div");
      headerLogo.setAttribute("aria-hidden", "true");

      const closeButton = document.querySelector(".global-link-close button");
      closeButton.setAttribute("aria-hidden", "true");

      const globalLink = document.querySelector(".global-link-header-link .global-link-item a");
      globalLink.setAttribute("aria-hidden", "true");

            // Focus the intended item
      setTimeout(() => {
        focusTarget.setAttribute("tabindex", "-1");
        focusTarget.focus();
      }, 50);

      // Restore children visibility after screen reader announcement
      setTimeout(() => {
        allChildren.forEach((child) => {
          child.removeAttribute("aria-hidden");
        });
        headerLogo.removeAttribute("aria-hidden");
        closeButton.removeAttribute("aria-hidden");
        globalLink.removeAttribute("aria-hidden");

      }, 1500); // Wait 1s for NVDA to finish reading


      setTimeout(() => {
        $(".global-link-item a").focus();
      }, 500)


      const $activeSection = $panel.find(
        ".global-link-wrapper-section-" + currentSection
      );

      // Wait briefly for DOM to update before trapping focus
      setTimeout(() => {
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        if (isMobile) {
          trapFocus($activeSection, true); // Call mobile trapFocus
        } else {
          trapFocusForDesktop($panel, true); // Call desktop trapFocus
        }

        // Optionally focus the first element
       
      }, 100);
    } else {
      console.warn(`Panel with ID ${targetID} not found`);
    }
  });

  if (isMobile) {
    function trapFocus($panel, includeCloseBtn = false) {
      $panel.off("keydown.trapFocus");

      let isRedirectingFocus = false;

      $panel.on("keydown.trapFocus", function (e) {
        if (e.key !== "Tab") return;

        // Dynamically calculate everything on every tab press
        let $focusable = $panel
          .find('a, button, [tabindex]:not([tabindex="-1"])')
          .filter(":visible");

        let $closeBtn = $(".global-link-close button:visible");
        let $globalLinkHeader = $(".global-link-item a:visible");
        let $globalLinkHeaderLogo = $(".global-link-header-logo:visible");

        if ($globalLinkHeaderLogo.length || $closeBtn.length) {
          // Remove them from the existing focusables (if present)
          $focusable = $focusable.not($closeBtn).not($globalLinkHeaderLogo);

          // Add in preferred order: logo → close → rest
          $focusable = $globalLinkHeaderLogo
            .add($closeBtn)
            .add($focusable);
        }

        const first = $focusable.first();
        const last = $focusable.last();

        const active = document.activeElement;

        if (isRedirectingFocus) {
          isRedirectingFocus = false;
          return;
        }

        if (active === first[0]) {
          e.preventDefault();
          isRedirectingFocus = true;
          setTimeout(() => {
            if (includeCloseBtn && $closeBtn.length) {
              $closeBtn.focus();
            } else {
              last.focus();
            }
          }, 10);
        } else if (active === last[0]) {
          e.preventDefault();
          if (includeCloseBtn && $closeBtn.length) {
            setTimeout(() => {
              if (includeCloseBtn && $closeBtn.length) {
                $closeBtn.focus();
              } else {
                last.focus();
              }
              isRedirectingFocus = false;
            }, 10);
          }
        } else if (active === $closeBtn[0]) {
          e.preventDefault();
          const $headerLink = $(".global-link-header-link a:visible");
          if ($headerLink.length) {
            $headerLink.focus();
          } else {
            const $activePanel = $(
              ".global-link-wrapper-section-3:visible, .global-link-wrapper-section-2:visible"
            );
            const $backBtn = $activePanel.find(".global-link-backBtn:visible");
            if ($backBtn.length) {
              $backBtn.focus();
            } else {
              $focusable.first().focus();
            }
          }
        } else if (
          $globalLinkHeader.length &&
          active === $globalLinkHeader[0]
        ) {
          const $activePanel = $(
            ".global-link-wrapper-section-" + currentSection
          );
          const $backBtn = $activePanel.find(".global-link-backBtn:visible");
          if ($backBtn.length) {
            setTimeout(() => {
              $backBtn.focus();
            }, 50);
          }
        }
      });
    }

    function slideTo(sectionIndex) {
      currentSection = sectionIndex;

      // Remove active from all panels
      $(".global-link-wrapper-section").removeClass("active");

      // Add to the current one
      $(`.global-link-wrapper-section-${sectionIndex}`).addClass("active");

      // Move panel
      const offset = (sectionIndex - 1) * -100;
      $wrapper.css("transform", `translateX(${offset}vw)`);
    }


    // Trap focus on panel 1 after slight delay
    setTimeout(() => {
      const $panel1 = $(".global-link-wrapper-section-1");
      trapFocus($panel1, true); // includeHeader true to include close button
    }, 200);

    $(".first-level").on("click", function (e) {
      e.preventDefault();
      const targetID = $(this).data("target");

      $(".global-link-wrapper-section-2 ul").hide();
      $(`#${targetID}`).show();

      $(".global-link-wrapper-section-2 .global-link-navTitle").text(
        $(this).text()
      );
      $(".global-link-wrapper-section-2 .global-link-backBtn").attr(
        "aria-label",
        "Back to " + $(this).text()
    ); 
      slideTo(2);

      // Set focus to back button
      const $panel2 = $(".global-link-wrapper-section-2");
      setTimeout(() => {
        $panel2.find(".global-link-backBtn").focus();
        trapFocus($panel2, true);
      }, 200);
    });

    $(".second-level").on("click", function (e) {
      e.preventDefault();
      const targetID = $(this).data("target");

      $(".brand-wrapper > div").hide();
      $(`[id='${targetID}']`).show();

      $(".global-link-wrapper-section-3 .global-link-navTitle").text(
        $(this).text()
      );

      $(".global-link-wrapper-section-3 .global-link-backBtn").attr(
          "aria-label",
          "Back to " + $(this).text()
      ); 

      slideTo(3);

      const $panel3 = $(".global-link-wrapper-section-3");
      setTimeout(() => {
        $panel3.find(".global-link-backBtn").focus();
        trapFocus($panel3, true);
      }, 200);
    });

    // Back buttons
    $(".global-link-wrapper-section-2 .global-link-backBtn").on(
      "click",
      function () {
        slideTo(1);
        const $panel1 = $(".global-link-wrapper-section-1");
        setTimeout(() => {
          $panel1.find("button.first-level").first().focus();
          trapFocus($panel1, true); // Re-apply focus trap on panel 1
        }, 200);
      }
    );

    $(".global-link-wrapper-section-3 .global-link-backBtn").on(
      "click",
      function () {
        slideTo(2);
        const $panel2 = $(
          ".global-link-wrapper-section-2 .second-level:visible"
        )
          .first()
          .focus();
        setTimeout(() => {
          $panel2.find("global-link-backBtn").first().focus();
          trapFocus($panel2, true); // Re-apply focus trap on panel 1
        }, 200);
      }
    );
    //trapFocus($("#global-link-wrapper"));
  }
  //trapFocus($('#global-link-wrapper-desktop'), true);
  else {
    function trapFocusForDesktop($panel, includeCloseBtn = false) {
      $panel.off("keydown.trapFocus");
      //clearFocusTrap();
      let $focusable = $panel
      .find('a, button, [tabindex]:not([tabindex="-1"])')
      .filter(":visible");

    let $closeBtn = $(".global-link-close button:visible");
    let $globalLinkHeader = $(".global-link-item a:visible");
    let $globalLinkHeaderLogo = $(".global-link-header-logo:visible");

    if ($globalLinkHeaderLogo.length || $closeBtn.length) {
      // Remove them from the existing focusables (if present)
      $focusable = $focusable.not($closeBtn).not($globalLinkHeaderLogo);

      // Add in preferred order: logo → close → rest
      $focusable = $globalLinkHeaderLogo
        .add($closeBtn)
        .add($focusable);
    }

      const first = $focusable.first();
      const last = $focusable.last();

      let isRedirectingFocus = false; // <-- Prevent double handling

      $panel.on("keydown.trapFocus", function (e) {
        if (e.key !== "Tab") return;

        if (isRedirectingFocus) {
          isRedirectingFocus = false; // reset and skip this pass
          return;
        }

        const active = document.activeElement;

        if (active === first[0]) {
          e.preventDefault();
          isRedirectingFocus = true;
          setTimeout(() => {
            if (includeCloseBtn && $closeBtn.length) {
              $closeBtn.focus();
            } else {
              last.focus();
            }
            isRedirectingFocus = false;
          }, 10);
        } else if (active === last[0]) {
          e.preventDefault();
          if (includeCloseBtn && $closeBtn.length) {
            setTimeout(() => {
              if (includeCloseBtn && $closeBtn.length) {
                $closeBtn.focus();
              } else {
                last.focus();
              }
              isRedirectingFocus = false;
            }, 10);
          }
        } else if (active === $closeBtn[0]) {
          e.preventDefault();

          const $headerLink = $(".global-link-header-link a:visible");
          if ($headerLink.length) {
            $headerLink.focus();
          } else {
            const $activePanel = $(
              ".global-link-wrapper-section-3:visible, .global-link-wrapper-section-2:visible"
            );
            const $backBtn = $activePanel.find(".global-link-backBtn:visible");
            if ($backBtn.length) {
              $backBtn.focus();
            } else {
              $panel.find("a, button").first().focus();
            }
          }
        } else if (active === $globalLinkHeader[0]) {
          const $activePanel = $(
            ".global-link-wrapper-section-" + currentSection
          );
          const $backBtn = $activePanel.find(".global-link-backBtn:visible");
          if ($backBtn.length) {
            setTimeout(() => {
              $backBtn.focus();
            }, 50);
          }
        }
      });
    }

    document.querySelectorAll(".accordion-item").forEach((item) => {
      item.addEventListener("shown.bs.collapse", () => {
        const links = item.querySelectorAll(".second-level");

        links.forEach((link) => {
          link.addEventListener("click", function (e) {
            e.preventDefault();

            const targetId = this.getAttribute("data-target"); // e.g., "subMenu-Belgium"
            const brandWrapper = item.querySelector(".brand-wrapper");

            // Hide all submenus inside brand-wrapper
            brandWrapper
              .querySelectorAll('div[id^="subMenu-"]')
              .forEach((div) => {
                div.style.display = "none";
              });

            // Remove active class from all links
            links.forEach((l) => l.classList.remove("active-region-link"));

            // Add active class to current link
            this.classList.add("active-region-link");

            // Show the selected target section
            const targetSection = brandWrapper.querySelector(`#${targetId}`);
            if (targetSection) {
              targetSection.style.display = "block";
              brandWrapper.style.display = "block";
            }
          });
        });
      });

      item.addEventListener("hide.bs.collapse", () => {
        const brandWrapper = item.querySelector(".brand-wrapper");
        if (brandWrapper) {
          brandWrapper.style.display = "none";
          brandWrapper
            .querySelectorAll('div[id^="subMenu-"]')
            .forEach((div) => {
              div.style.display = "none";
            });

          // Optionally, remove active class from all links
          const links = item.querySelectorAll(".second-level");
          links.forEach((link) => link.classList.remove("active-region-link"));
        }
      });
    });

    trapFocusForDesktop($("#desktop-global-link-wrapper"), true);
  }
});